'use strict';

/*
 * @ngdoc function
 * @name cimerFrontEndApp.controller:SearchCurriculaCtrl
 * @description
 * # SearchCurriculaCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
    .controller('SearchCurriculaCtrl',
    [
        '$scope', '$location', '$uibModal', '$q', 'Session', 'DocumentService', 'BookBagService', '$sce', '$window', '$routeParams',
        function ($scope, $location, $uibModal, $q, Session, DocumentService, BookBagService, $sce, $window, $routeParams) {

            if ($routeParams.roleId) {
                $scope.selectedRoleId = $routeParams.roleId; //parseInt($routeParams.roleId, 10);
            } else {
                $scope.selectedRoleId = '1';
            }

            //Handles asking someone for their login
            var login = function () {
                var loginModal = $uibModal.open({
                    animation: true,
                    templateUrl: '/Content/Templates/loginModal.html?v=' + versionKey,
                    controller: 'loginModalCtrl',
                    resolve: {
                        Session: function () {
                            return Session;
                        }
                    }

                });
                loginModal.rendered.then(function () {
                    $('#username').focus();
                });
                loginModal.result.then(function () {
                    sessionObject = Session.getSessionObject();
                    location.reload();
                }, function () { // close or cancel
                    if ($scope.selectedRoleId === '1') {
                        $location.url('/customMentorCurricula');
                    }
                    else {
                        $location.url('/customMenteeCurricula');
                    }
                });
            };

            //route away if not authenticated
            var sessionObject = Session.getSessionObject();
            if (!sessionObject.isAuthenticated) {
                login();
                return;
            }

            /* Cimer-262: Trainee development areas are associated with "Meta-Learning Objectives" 
             * When filtering on Trainee Development Area, only certain Meta-Learning Objectives should be shown (even if a doc is tagged with the TDA)
             * The TDAs are tags with category ID 4 in the Tags table, the MLOs are tags with category ID 7 in the Tags table
             * We currently don't have a way to associate the MLOs and TDAs in the database, so manually build a map here
             * Cimer sent us the list of which MLOs go with which TDAs, it's in Confluence (CIMER -> Curricula -> Custom Curricula -> Meta-Learning Objectives and Trainee Development Area Associations)
             * If you update the TDA/MLO associations, please update the document as well
             * The tag IDs aren't consistent across Dev/Staging/Prod databases, so we need to use the tag text
             * */
            $scope.objectivesDict = {};
            $scope.objectivesDict["Research Comprehension & Communication Skills"] = ["Develop effective interpersonal communication skills", "Establish & maintain professional relationships", "Develop disciplinary knowledge", "Develop science communication skills", "Develop logical/critical thinking skills", "Develop understanding of the research environment"];
            $scope.objectivesDict["Practical Research Skills"] = ["Develop ability to design a research project", "Develop ability to conduct a research project"];
            $scope.objectivesDict["Research Ethics"] = ["Develop responsible & ethical research practices"];
            $scope.objectivesDict["Researcher Identity"] = ["Develop identity as researcher"]; // The tag text is exactly this, not "as a researcher"
            $scope.objectivesDict["Researcher Confidence & Independence"] = ["Develop independence as a researcher", "Develop confidence as a researcher"];
            $scope.objectivesDict["Equity & Inclusion Awareness & Skills"] = ["Develop skills to deal with personal differences in the research environment", "Advance equity and inclusion in the research environment"];
            $scope.objectivesDict["Professional & Career Development Skills"] = ["Explore & pursue a research career", "Develop confidence in pursuing a research career"];
            $scope.objectivesDict["Mentoring Skills"] = ["Maintain effective communication", "Align expectations", "Assess understanding", "Address equity and inclusion", "Foster independence", "Promote professional development", "Articulate a mentoring philosophy", "Promote mentee research self-efficacy", "Promote work-life integration"];

            $scope.defaultIndex = 0;  //index of the categoriesList that represents the category we will actually display
            //but if we come in as mentee, we need to change the default category 
            if ($scope.selectedRoleId === '2') {
                $scope.defaultIndex = 6;
            }

            $scope.dataLoaded = false;

            $scope.filterSelection = {};
            $scope.searchDropDownsettings = {
                externalIdProp: '',
                idProp: 'TagId',
                displayProp: 'Description',
                enableSearch: false,
                showCheckAll: false,
                showUncheckAll: true,
                showEnableSearchButton: false
            };
            $scope.searchDropDownText = {
                buttonDefaultText: 'All'
            };
            $scope.bookBagList = [];
            $scope.documentList = [];
            $scope.tagDict = {};
            $scope.categoryList = [];
            $scope.researchRoleList = [];
            $scope.tagGroupNames = [];
            $scope.selectedMaterialTypeId = {};
            var complete = {};      //materials type object
            var participant = {};   //materials type object

            //store the complete and participant objects for later use
            var setUpMaterialsType = function () {
                for (var i = 0; i < $scope.tagDict[6].length; i++) {
                    if ($scope.tagDict[6][i].TagId === 49)
                        complete = $scope.tagDict[6][i];
                    else if ($scope.tagDict[6][i].TagId === 50)
                        participant = $scope.tagDict[6][i];
                }
            };

            //set the default value for Materials Type
            var setDefaultMaterialsType = function () {
                $scope.selectedMaterialTypeId = 49; //set Materials Type to Complete
                if (+$scope.selectedRoleId === 2) { //research role is Trainee
                    setUpMaterialsType();
                    $scope.filterSelection[6] = [complete]; //actually filter if it's the right role
                }
            };

            $scope.roleChange = function (role) {
                $scope.selectedRoleId = role;
                $scope.dataLoaded = false;

                if (role === "1") {
                    $scope.defaultIndex = 0;
                } else {
                    //for trainees, we are organizing by meta learning objectives
                    $scope.defaultIndex = 6;
                }

                // Clear all filters on changing role since different filters apply to different roles
                for (var i = 1; i < 8; i++) { // There are 8 filter categories, but since filterSelection isn't an array, we can't use .length. Also it starts at one for an unknown reason, not zero.
                    $scope.filterSelection[i] = [];
                }
                
                setDefaultMaterialsType();

                DocumentService.getDocumentsByResearchRole($scope.selectedRoleId)
                    .then(function (response) {
                        $scope.documentList = response.data;
                        $scope.dataLoaded = true;
                    });
            };

            //update "complete or participant" to filter on either or
            $scope.materialsTypeChange = function (selected) {
                switch (+selected) {
                    case -1: //all
                        $scope.filterSelection[6] = []; 
                        break;
                    case 49:
                        $scope.filterSelection[6] = [complete]; 
                        break;
                    case 50:
                        $scope.filterSelection[6] = [participant];
                        break;
                }
            };

            //Load bookBagService object if available (routed from Bookbag page) and add to document list
            $scope.bookBagObject = BookBagService.getBookBagObject();
            var tempObj = {};
            for (var i = 0; i < $scope.bookBagObject.docs.length; i++) {
                tempObj = {
                    DocumentID: $scope.bookBagObject.docs[i].docID,
                    bookBagDocID: $scope.bookBagObject.docs[i].bookBagDocID,
                    title: $scope.bookBagObject.docs[i].title,
                    docOrder: $scope.bookBagObject.docs[i].docOrder,
                    isSelected: $scope.bookBagObject.docs[i].isSelected
                };
                $scope.bookBagList.push(tempObj);
            }

            DocumentService.getResearchRoles()
                .then(function (result) {
                    $scope.researchRoleList = result.data;
                    // For now, we don't want any Custom Curricula for the Mentoring Up role, so manually remove it here
                    $scope.researchRoleList.splice($scope.researchRoleList.indexOf(3), 1);
                });

            //Get Categories - then set default and grab default documents and tags
            DocumentService.getCategories().then(function (result) {
                $scope.categoryList = result.data;

                //now grab all the tags
                var promises = [];
                for (var i = 0; i < $scope.categoryList.length; i++) {
                    promises.push(
                        DocumentService.getTagsByCategory($scope.categoryList[i].CategoryID)
                    );
                }
                // and documents for the default category ($scope.defaultIndex)
                promises.push(
                    //get all documents for selected role
                    DocumentService.getDocumentsByResearchRole($scope.selectedRoleId)
                );

                $q.all(promises).then(function (responses) {
                    //console.log(responses);
                    for (var i = 0; i < $scope.categoryList.length; i++) {
                        $scope.filterSelection[$scope.categoryList[i].CategoryID] = [];
                        $scope.tagDict[$scope.categoryList[i].CategoryID] = responses[i].data;
                    }

                    //add "All" to beginning of Materials Type list and "Complete or Participant" to end of list
                    var category = $scope.tagDict[6][0].Category;
                    $scope.tagDict[6].unshift({ Category: category, Description: "All", LongDescription: null, TagId: -1, TagOrder: 29}); //add to beginning
                    setUpMaterialsType();
                    setDefaultMaterialsType();

                    $scope.documentList = responses[responses.length - 1].data;
                    for (var tagKey in $scope.documentList) {
                        if ($scope.documentList.hasOwnProperty(tagKey)) {
                            for (var k = 0; k < $scope.documentList[tagKey].length; k++) {
                                $scope.documentList[tagKey][k].isInBookbag = false;

                                for (var j = 0; j < $scope.bookBagList.length; j++) {
                                    if ($scope.documentList[tagKey][k].DocumentID === $scope.bookBagList[j].DocumentID) {
                                        $scope.documentList[tagKey][k].isInBookbag = true;
                                        break;
                                    }
                                }
                            }
                        }
                    } //end for tagKey
                    
                    // Get the grouping tags' description so we can filter them out when displaying the tags
                    for (var m = 0; m < $scope.tagDict[7].length; m++) {
                        $scope.tagGroupNames.push($scope.tagDict[7][m].Description);
                    }

                    $scope.dataLoaded = true;

                    // console.log("categories: ", $scope.categoryList);
                    // console.log("tags: ", $scope.tagDict); 
                    // console.log("documents: ", $scope.documentList);
                });

            }, function (err) {
                $scope.dataLoaded = false;
                console.log(err);
            });

            $scope.filterDefaultCategory = function (tag) {

                var defaultCategoryID = $scope.categoryList[$scope.defaultIndex].CategoryID;

                if ($scope.filterSelection[defaultCategoryID].length === 0) { //if this is empty, nothing has been checked, so all are allowed
                    return true;
                } else {
                    for (var i = 0; i < $scope.filterSelection[defaultCategoryID].length; i++) {
                        //otherwise, if its in the list, its checked, so display
                        if (tag.TagId === $scope.filterSelection[defaultCategoryID][i].TagId) {
                            return true;
                        }
                    }
                    //otherwise don't
                    return false;
                }

            };

            $scope.filterMetaLearningObjectives = function (tag) {
                // We only care about the filter on Training Development area, $scope.filterSelection[4]
                // Return everything if no filter selected
                if ($scope.filterSelection[4].length === 0) { return true; }
                for (var i = 0; i < $scope.filterSelection[4].length; i++) {
                    var devAreaDesc = $scope.filterSelection[4][i].Description;
                    if ($scope.objectivesDict[devAreaDesc].indexOf(tag.Description) > -1) {
                        return true;
                    }
                }
                // If we got here, the tag isn't associated with any of the selected development areas, don't show it
                return false;
            };

            $scope.filterDocuments = function (doc) {

                //check filtering in all non-default categories
                for (var i = 0; i < $scope.categoryList.length; i++) {

                    var categoryID = $scope.categoryList[i].CategoryID;
                    if (i === $scope.defaultIndex) { //skip default category
                        continue;
                    }

                    //check if any of the doc's tags match a tag in the list
                    if ($scope.filterSelection[categoryID].length === 0) { //no filtering on this tag category if empty
                        continue;
                    }
                    var inList = false;
                    for (var j = 0; j < $scope.filterSelection[categoryID].length; j++) {
                        for (var k = 0; k < doc.DocumentTags.length; k++) {
                            if ($scope.filterSelection[categoryID][j].TagId === doc.DocumentTags[k].Tag.TagId) {
                                inList = true;
                                break;
                            }
                        }
                    }

                    //if it wasn't in the list, but there was a list, don't display
                    if (!inList) {
                        return false;
                    }

                }

                //if we made it this far it should be displayed
                return true;
            };

            $scope.filterTagFunction = function () {

                return function (tag) {

                    return true;

                    //TODO: implement me !

                    /* if ($scope.filterSelection[catID].length === 0) { //if this is empty, nothing has been checked, so all are allowed
                         return true;
                     } else {
                         //something has been checked, if checked, display
                         for (var i = 0; i < $scope.filterSelection[catID].length; i++) {
                             if (tag.TagId === $scope.filterSelection[catID][i].TagId) {
                                 return true;
                             }
                         }
                         //otherwise don't display
                         return false;
                     }      */
                };

            };

            $scope.filterTagDisplay = function (tag) {
                return $scope.tagGroupNames.indexOf(tag.Tag.Description) < 0;        
            };

            $scope.updateBookbag = function (document) {
                var duplicateFound = false;

                if (!document.isInBookbag) {
                    //need to actually look in the bookbag to see if there's any with the same id
                    angular.forEach($scope.bookBagList,
                        function(b) {
                            if (b.DocumentID === document.DocumentID) {
                                //don't add anything, but let the document know it's in the bookbag
                                duplicateFound = true;
                            }
                        });
                    if (!duplicateFound) {
                    document.isInBookbag = true;
                    var newOrder = $scope.bookBagList.length + 1;
                        $scope.bookBagList.push({
                            DocumentID: document.DocumentID,
                            bookBagDocID: null,
                            title: document.Title,
                            docOrder: newOrder,
                            isSelected: true
                        });
                    }
                } else {
                    document.isInBookbag = false;
                    for (var i = 0; i < $scope.bookBagList.length; i++) {
                        if ($scope.bookBagList[i].DocumentID === document.DocumentID) {
                            $scope.bookBagList.splice(i, 1);
                            break;
                        }
                    }
                }
            };

            $scope.downloadDocument = function (doc) {
                var fileName = "CustomCurricula_" + doc.FileName;
                DocumentService.getPDFDocumentForDownload(doc.DocumentID).then(function (result) {
                    var file = new Blob([result.data], { type: 'application/pdf' });
                    var fileURL = window.URL.createObjectURL(file);
                    var content = $sce.trustAsResourceUrl(fileURL);
                    //$window.open(content, '_blank');
                }, function () {
                    $scope.DocPreview = null;
                    a.click();
                }, function () {
                    $scope.DocPreview = null;
                });
            };

            $scope.goToBookBag = function () {

                //save current document list to BookBagService to pass to bookbag service if there's anything there:
                var tempDocs = [];
                for (var i = 0; i < $scope.bookBagList.length; i++) {
                    tempDocs.push({
                        docID: $scope.bookBagList[i].DocumentID,
                        bookBagDocID: $scope.bookBagList[i].bookBagDocID,
                        title: $scope.bookBagList[i].title,
                        docOrder: $scope.bookBagList[i].docOrder,
                        isSelected: $scope.bookBagList[i].isSelected
                    });
                }
                BookBagService.saveBookBagObject({
                    bookBagID: $scope.bookBagObject.bookBagID,
                    name: $scope.bookBagObject.name,
                    description: $scope.bookBagObject.description,
                    docs: tempDocs
                });

                $location.url('/myCurricula');
            };

}]);